import { keys } from "lodash";
import moment from "moment";
import { from, Observable } from "rxjs";
import { API } from "../../services/http";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { processErrorFromPromise } from "../errors/utils";
import { StakingDTO } from "./models/dto";

function processStats(stats: any): StakingDTO.Responses.GetStats.T {
  return {
    ...stats,
    stakingTimeline: keys(stats.stakingTimeline).map((key) => [
      moment(key),
      stats.stakingTimeline[key],
    ]),
  };
}

export namespace StakingService {
  const api = new API("chain");

  export function getStats(): Observable<
    FetchableError | FetchableSuccess<StakingDTO.Responses.GetStats.T>
  > {
    return from(
      api
        .get(`staking`)
        .then<FetchableSuccess<StakingDTO.Responses.GetStats.T>>(
          (response) => ({
            status: "ready",
            data: response.body.map(processStats),
          })
        )
        .catch<FetchableError>(processErrorFromPromise)
        .catch<FetchableError>((err) => ({
          status: "error",
          err,
        }))
    );
  }

  export function getStakingItem(id: string) {}
}
